import OrderMessageItem from './Order';

export enum StreamMessageType {
    /*
     * Clear all data from the order data array
     */
    ClearData = 0,
    /*
     * Payload is array of order objects (length 500). This always represents a partial delivery of a batched order update.
     */
    BatchData = 1,
    /*
     * Every 10th data update in a batch request (preceded by 9 BATCH_DATA messages).
     * Also the last data update will always be a BATCH_DONE rather than a BATCH_DATA message.
     * Or an incremental update (i.e. communicating changes in order field values without changing the list of orders or adding columns).
     *
     */
    BatchDone = 2,
    /*
     * Send on completion of a batch
     */
    RefreshDone = 3,
}

export type OrderDataMessageItemUpdateOrder = Partial<OrderMessageItem> & {
    idx: number;
};
export type OrderDataMessageItemReplaceOrder = OrderMessageItem & {
    showOrder: true;
    idx: number;
};
export interface OrderDataMessageItemHideOrder {
    showOrder: false;
    idx: number;
}
export interface OrderDataMessageRemoveMultipleOrders {
    clearOff: number;
    clearMod: number;
}

export type OrderDataMessageDataItem =
    | OrderDataMessageItemUpdateOrder
    | OrderDataMessageItemReplaceOrder
    | OrderDataMessageItemHideOrder
    | OrderDataMessageRemoveMultipleOrders;

export interface GetOrderColumnsDataMessage {
    type: StreamMessageType.BatchDone | StreamMessageType.BatchData;
    data: OrderDataMessageDataItem[] | null;
}

export interface GetOrderColumnsClearDataMessage {
    type: StreamMessageType.ClearData;
}

export interface GetOrderColumnsRefreshDoneMessage {
    type: StreamMessageType.RefreshDone;
    numOrdersUpdated: number;
    numMergedRequests: number;
}

export type GetOrderColumnsMessage =
    | GetOrderColumnsClearDataMessage
    | GetOrderColumnsDataMessage
    | GetOrderColumnsRefreshDoneMessage;

export function isOrderMessageDataItemHideOrder(
    msg: OrderDataMessageDataItem
): msg is OrderDataMessageItemHideOrder {
    const hideOrder = msg as OrderDataMessageItemHideOrder;
    return hideOrder.showOrder !== undefined && !hideOrder.showOrder;
}

export function isOrderMessageDataItemReplaceOrder(
    msg: OrderDataMessageDataItem
): msg is OrderDataMessageItemReplaceOrder {
    const replaceOrder = msg as OrderDataMessageItemReplaceOrder;
    return replaceOrder.showOrder !== undefined && replaceOrder.showOrder;
}

export function isOrderMessageDataItemRemoveMultipleOrders(
    msg: OrderDataMessageDataItem
): msg is OrderDataMessageRemoveMultipleOrders {
    const replaceOrder = msg as OrderDataMessageRemoveMultipleOrders;
    return replaceOrder.clearOff !== undefined;
}

export function isRefreshDoneMessage(message: GetOrderColumnsMessage): boolean {
    return message.type === StreamMessageType.RefreshDone;
}
